import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import { handleError } from '../../utils/api-error-handling';

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: baseQuery,
  tagTypes: ['EmailConfig'],
  endpoints: (builder) => ({
    getNotificationList: builder.query({
      query: (params) => `lists/notifications/header/${params}`,
      providesTags: ['EmailConfig'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
      forceRefetch() {
        return true;
      },
      keepUnusedDataFor: 0.0001,
    }),
  }),
});

export const { useGetNotificationListQuery } = notificationApi;
